var _path, _path2, _path3, _circle, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 47,
    viewBox: "0 0 32 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16C31 18.1879 30.5322 20.2638 29.6922 22.1354C29.6919 22.136 29.6917 22.1365 29.6914 22.1371L29.6519 22.2241L17.5219 44.9484C16.9835 45.7311 16.4205 45.9705 16.0027 45.9706C15.5848 45.9706 15.0218 45.7314 14.4833 44.9488L2.34764 22.2233L2.32933 22.1831C2.32916 22.1827 2.32898 22.1823 2.32881 22.182C1.47556 20.2982 1 18.206 1 16Z",
    fill: "white",
    stroke: "#5A98E2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.92 16.7062C24.92 21.2921 20.9369 25.0096 16.0235 25.0096C11.1101 25.0096 7.12695 21.2921 7.12695 16.7062C7.12695 12.1204 11.1101 8.40282 16.0235 8.40282C20.9369 8.40282 24.92 12.1204 24.92 16.7062Z",
    fill: "url(#paint0_linear_3479_110)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2986 6.55762H16.6166V8.66642H15.2986V6.55762Z",
    fill: "url(#paint1_linear_3479_110)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9565,
    cy: 4.97655,
    r: 1.8452,
    fill: "#000F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0931 25.6695C21.3341 25.6695 25.5827 21.7159 25.5827 16.8389C25.5827 13.8901 24.0296 11.2789 21.643 9.67507C21.4214 9.52615 21.1579 9.45459 20.891 9.45459H11.2953C11.0283 9.45459 10.7649 9.52615 10.5433 9.67507C8.15669 11.2789 6.60352 13.8901 6.60352 16.8389C6.60352 21.7159 10.8522 25.6695 16.0931 25.6695Z",
    fill: "url(#paint2_linear_3479_110)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.4375,
    y: 22.1113,
    width: 0.1977,
    height: 1.3839,
    rx: 0.0988502,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.625,
    y: 22.1113,
    width: 0.1977,
    height: 1.3839,
    rx: 0.0988502,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0312,
    y: 21.7153,
    width: 0.1977,
    height: 2.3724,
    rx: 0.0988502,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.48249,
    y: 11.8311,
    width: 15.2888,
    height: 8.03981,
    rx: 4.01991,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 0.527201
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2805 15.3888C14.2805 15.2157 14.2464 15.0443 14.1802 14.8844C14.114 14.7245 14.0169 14.5792 13.8945 14.4568C13.7721 14.3344 13.6268 14.2374 13.4669 14.1711C13.307 14.1049 13.1356 14.0708 12.9625 14.0708C12.7895 14.0708 12.6181 14.1049 12.4582 14.1711C12.2982 14.2374 12.153 14.3344 12.0306 14.4568C11.9082 14.5792 11.8111 14.7245 11.7449 14.8844C11.6786 15.0443 11.6445 15.2157 11.6445 15.3888",
    stroke: "#72B2FF",
    strokeWidth: 0.659001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8723 15.3888C20.8723 15.2157 20.8382 15.0443 20.772 14.8844C20.7058 14.7245 20.6087 14.5792 20.4863 14.4568C20.3639 14.3344 20.2186 14.2374 20.0587 14.1711C19.8988 14.1049 19.7274 14.0708 19.5543 14.0708C19.3812 14.0708 19.2099 14.1049 19.05 14.1711C18.89 14.2374 18.7447 14.3344 18.6224 14.4568C18.5 14.5792 18.4029 14.7245 18.3367 14.8844C18.2704 15.0443 18.2363 15.2157 18.2363 15.3888",
    stroke: "#72B2FF",
    strokeWidth: 0.659001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3479_110",
    x1: 16.0235,
    y1: 6.55762,
    x2: 16.0235,
    y2: 25.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3479_110",
    x1: 16.0235,
    y1: 6.55762,
    x2: 16.0235,
    y2: 25.0096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3479_110",
    x1: 16.0931,
    y1: 8.00824,
    x2: 16.0931,
    y2: 25.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ae53beeb70ba9d53c8eaa5c9430f6da4.svg";
export { ForwardRef as ReactComponent };